const postWebViewMessage = (type, data = {}) => {
  window.ReactNativeWebView?.postMessage(JSON.stringify({
    type,
    ...data
  }));
};

const appNavigate = (tab, params = {}) => {
  postWebViewMessage('navigate', { tab, params });
};

const postLoginStatus = ({ isLoggedIn, username, logo, hasInterventionPointTab, email, role, canCreateRequests }) => {
  postWebViewMessage('loggedIn', { isLoggedIn, username, logo, hasInterventionPointTab, email, role, canCreateRequests });
};

export { appNavigate, postWebViewMessage, postLoginStatus };